import { types, API_URL } from './types';
import { axiosApi } from './index';
import { clearPermissionsCache } from '../../utils/permissions';

export const signIn = (email, password) => {
  const url = `${API_URL}/api/auth/sign_in`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      email: email,
      password: password,
    };
    axiosApi
      .post(url, params)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message || 'Usuario o clave incorrecta!';
          dispatch(setSignIn(outputData));
        } else {
          localStorage.setItem('token', data['AUTH-TOKEN']);
          localStorage.setItem('role', data['role']);
          localStorage.setItem('email', email);
          localStorage.setItem('permissions', JSON.stringify(data['permissions'] || {}));
          clearPermissionsCache();
          outputData['token'] = data['AUTH-TOKEN'];
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          dispatch(setSignIn(outputData));
        }
      })
      .catch((err) => {
        const message =
          err.response?.data?.message || 'Error de conexión. Intente nuevamente.';
        outputData['status'] = 'danger';
        outputData['message'] = message;
        dispatch(setSignIn(outputData));
      });
  };
};

export const setSignIn = (data) => ({
  type: types.signIn,
  payload: data,
});

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('email');
  localStorage.removeItem('permissions');
  clearPermissionsCache();

  return (dispatch) => {
    dispatch(setLogout());
  };
};

export const setLogout = () => {
  return {
    type: types.signOut,
    payload: { token: null, status: null, message: null, signIn: null },
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(logout());
      return;
    }
    dispatch(setSignIn({ token: token }));
  };
};
